import type { PatientFile } from "@/features/patient/types/PatientFile";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getPatientFiles(patientId: string): Promise<PatientFile[]> {
  return sharedRequestsTyped.get_files({
    body: { entity_id: patientId, entity_type: "patient" },
  });
}
